package app.nestbridge.feature.messages.presentation

import app.nestbridge.feature.messages.screen.MessagesScreen
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.Navigator
import com.slack.circuit.runtime.presenter.Presenter
import com.slack.circuit.runtime.screen.Screen
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
@Origin(MessagesPresenter::class)
public class MessagesPresenterFactory(
  private val provider: () -> MessagesPresenter,
) : Presenter.Factory {
  override fun create(
    screen: Screen,
    navigator: Navigator,
    context: CircuitContext,
  ): Presenter<*>? = when (screen) {
    MessagesScreen -> provider()
    else -> null
  }
}
